export enum SortDirection {
    ASC = 'ascending',
    DESC = 'descending',
}
